module.exports = __webpack_public_path__ + "static/img/06_img.cbaff88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company/sustainability/06_img.png
// module id = WNQZ
// module chunks = 0